import styled from '@emotion/styled';
import {
  CardButtonProduct,
  LinkWrapper,
  createMediaQuery,
  token,
} from '@ferreri/prever-component-lib';

type Data = {
  icon: React.ReactNode;
  title: string;
  uri: string;
};

type CardProductListProps = {
  data: Data[];
};

export const CardProductList = (props: CardProductListProps) => {
  return (
    <GridContainer>
      {props.data?.map(({ icon, uri, title }) => (
        <LinkWrapper href={uri} key={`${title}-${uri}`}>
          <CardButtonProduct icon={icon} textInfo={title} />
        </LinkWrapper>
      ))}
    </GridContainer>
  );
};

const GridContainer = styled.div`
  gap: ${token.spacing.spacingSmall};
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  ${createMediaQuery({
    tablet: {
      display: 'flex',
      flex: 1,
      flexWrap: 'wrap',
      alignItems: 'center',
    },
  })}
`;
